import { http, isHttpError, rawHttp } from '../http';

export type UploadedDocumentData = {
	docUlid: string;
	docPath: string;
	// Path 2 (public retrieval). False for sponsors on a custom bucket, whose
	// documents never reach Cybersign's public prefix. Null on backends that
	// predate the flag, which this client treats as "unknown, let the server
	// decide" (see src/pages/upload-document/util/public-retrieval-gate.ts).
	publicRetrievalAllowed: boolean | null;
}

export async function uploadDocument(document: File): Promise<UploadedDocumentData> {
	const uploadDocumentUrl = await http.post<{
		url: string;
		fields: Record<
			| 'key'
			| 'x-amz-algorithm'
			| 'x-amz-credential'
			| 'x-amz-date'
			| 'x-amz-security-token'
			| 'policy'
			| 'x-amz-signature',
			string
		>;
		doc_ulid: string;
		doc_path: string;
		public_retrieval_allowed?: boolean;
	}>('documents/upload-url', {
		file_tier: 'tier-3',
		file_name: document.name,
	});

	if (isHttpError(uploadDocumentUrl)) {
		throw new Error('getUploadUrl failed');
	} else {
		const formData = new FormData();
		formData.append('key', uploadDocumentUrl.fields.key);
		formData.append(
			'x-amz-algorithm',
			uploadDocumentUrl.fields['x-amz-algorithm'],
		);
		formData.append(
			'x-amz-credential',
			uploadDocumentUrl.fields['x-amz-credential'],
		);
		formData.append('x-amz-date', uploadDocumentUrl.fields['x-amz-date']);
		formData.append(
			'x-amz-security-token',
			uploadDocumentUrl.fields['x-amz-security-token'],
		);
		formData.append('policy', uploadDocumentUrl.fields.policy);
		formData.append(
			'x-amz-signature',
			uploadDocumentUrl.fields['x-amz-signature'],
		);
		formData.append('file', document, document.name);

		await rawHttp.post(uploadDocumentUrl.url, formData);

		return {
			docUlid: uploadDocumentUrl.doc_ulid,
			docPath: uploadDocumentUrl.doc_path,
			publicRetrievalAllowed:
				typeof uploadDocumentUrl.public_retrieval_allowed === 'boolean'
					? uploadDocumentUrl.public_retrieval_allowed
					: null,
		};
	}
}
